import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Rotate20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M3.75 1H2.25V7.75H9V6.25H4.32197C6.82761 2.94715 11.6867 2.14069 14.773 5.22703C17.409 7.86307 17.409 12.1369 14.773 14.773C12.137 17.409 7.86309 17.409 5.22705 14.773L4.16639 15.8336C7.38822 19.0555 12.6118 19.0555 15.8337 15.8336C19.0555 12.6118 19.0555 7.38819 15.8337 4.16637C12.4239 0.756596 6.93279 1.12802 3.75 4.60057V1Z'
      fill='currentColor'
    />
  </Svg>
);

Rotate20.displayName = 'Rotate20';
export default Rotate20;
